<template>
    <span class="auto-ring"
        :style="{'--size': size}"
    ></span>
</template>

<script lang="ts" setup>

const props = defineProps({
    size: {
        type: String,
        default: '18px',
    },
});

</script>

<style lang="scss" scoped>
.auto-ring {
    width: var(--size);
    line-height: 1;
    vertical-align: middle;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    &:after {
        content: "";
        display: inline-block;
        animation: auto-ring 1.2s linear infinite;
        border: 3px solid;
        border-radius: 50%;
        width: 13px;
        height: 13px;
        margin: 1px;
        border-color: #fff transparent;
    }
}

@keyframes auto-ring {
    0%{
        transform: rotate(0);
    }
    to {
        transform: rotate(1turn);
    }
}
</style>
